module.exports = __webpack_public_path__ + "56ba858118e83d9fc91cbbd173a11253.png";